const PF = "https://backendwhistler.herokuapp.com/images/";
//const PF = "http://localhost:8800/images/"
export default PF;